import { defineMessages } from 'react-intl';

import { SelectConfiguredOption } from '@app/hooks';
import { ITEM_STATUS } from '@app/constants';

const itemStatusPanelMessages = defineMessages({
  feeDue: {
    id: 'itemStatus.feeDue',
    defaultMessage: 'Fee due',
  },
  requested: {
    id: 'itemStatus.onRequest',
    defaultMessage: 'On request',
  },
  onHold: {
    id: 'itemStatus.onHold',
    defaultMessage: 'On hold',
  },
  checkedOut: {
    id: 'itemStatus.checkedOut',
    defaultMessage: 'Checked out',
  },
  onLoan: {
    id: 'itemStatus.onLoan',
    defaultMessage: 'On loan',
  },
  overdue: {
    id: 'itemStatus.overDue',
    defaultMessage: 'Overdue',
  },
});

export const getItemStatusPanelMessages = (
  selectConfiguredOption: SelectConfiguredOption
) => ({
  feeDue: itemStatusPanelMessages.feeDue,
  [ITEM_STATUS.onHold]: selectConfiguredOption(
    itemStatusPanelMessages.requested,
    itemStatusPanelMessages.onHold
  ),
  [ITEM_STATUS.checkedOut]: selectConfiguredOption(
    itemStatusPanelMessages.onLoan,
    itemStatusPanelMessages.checkedOut
  ),
  [ITEM_STATUS.overdue]: itemStatusPanelMessages.overdue,
});

export const itemStatusPanelButtonMessages = defineMessages({
  renew: {
    id: 'itemStatus.renew',
    defaultMessage: 'Renew',
  },
  goToRequestsAndLoans: {
    id: 'itemStatus.goToRequestsAndLoans',
    defaultMessage: 'Go to requests & loans',
  },
  goToHoldsAndCheckouts: {
    id: 'itemStatus.goToHoldAndCheckouts',
    defaultMessage: 'Go to holds & checkouts',
  },
});
